import type { CombinedError } from "urql";

const AUTH_ERROR_CODES = new Set(["UNAUTHENTICATED", "AUTHENTICATION_ERROR"]);

/**
 * URQLが返すCombinedErrorを認証エラーかどうか判定します。
 *
 * @param error 判定対象のエラー。
 * @returns 認証由来のエラーならtrue。
 */
export const isAuthenticationError = (
  error: CombinedError | null | undefined,
): boolean => {
  if (!error) {
    return false;
  }

  const status =
    (error.networkError as { status?: number; statusCode?: number } | undefined)
      ?.status ??
    (error.networkError as { statusCode?: number } | undefined)?.statusCode ??
    error.response?.status;
  if (status === 401) {
    return true;
  }

  return error.graphQLErrors.some((graphError) => {
    const code = graphError.extensions?.code;
    return typeof code === "string" && AUTH_ERROR_CODES.has(code.toUpperCase());
  });
};
